import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack, Typography } from '@optimus-web/core';
import { useEnterpriseNavigate } from '@mews-commander/ui';

interface NotFoundProps {
    enterpriseId: string;
}

export const ConfigurationNotFound = ({ enterpriseId }: NotFoundProps) => {
    const navigate = useEnterpriseNavigate();
    const handleGoToMarketplace = () => {
        const params = {
            OwnerId: enterpriseId,
            CategoryId: 'discovery',
            ApplicationId: 'SmsIntegration',
        };

        void navigate({ to: `EnterpriseIntegration/Marketplace`, search: params });
    };

    return (
        <Stack vertical spacing="300">
            <Typography textStyle="titleSmall" as="p">
                <LocalizedText textKey={TextKey.TextMessagingSubscriptionCallToAction} />
            </Typography>
            <Stack>
                <Button
                    data-test-id="go-to-marketplace"
                    onClick={handleGoToMarketplace}
                    size="medium"
                    type="button"
                    variant="primary"
                    wide={false}
                >
                    <LocalizedText textKey={TextKey.GoToMarketplace} />
                </Button>
            </Stack>
        </Stack>
    );
};
